// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--LZE0a";
export var footerInner = "Footer-module--footerInner--s71N4";
export var footerPoweredBy = "Footer-module--footerPoweredBy--quoBK";
export var footerSocial = "Footer-module--footerSocial--RsyM1";
export var footerSocialInner = "Footer-module--footerSocialInner--McjEg";
export var footerSocialLinks = "Footer-module--footerSocialLinks--7xHbr";